/** Verified eBay seller used as reference data when creating listings. */
export const VERIFIED_EBAY_SELLER = {
  username: 'carpartswholesale',
  label: 'Car Parts Wholesale',
  description:
    ' Listing creation uses listing data from this eBay seller account as the source template when building new catalog entries and marketplace listings.',
};

/** Default listing field values applied when compiling a new listing. */
export const DEFAULT_LISTING_FIELDS_CONFIG = {
  startPrice: '99.99',
  quantity: 0,
  conditionId: '1000',
  customItemSpecifics: [
    { Name: 'Brand', Value: 'Rev & Bolt' },
    { Name: 'Anticipated Ship Out Time', Value: '1-3 business days' },
    { Name: 'Warranty', Value: '1 year' },
    { Name: 'Returns Policy', Value: '30-Day Return Policy' },
  ],
  excludeItemSpecifics: ['UPC', 'California Prop 65 Warning'],
};
